<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { vodafoneLabNewsletterMixin } from "../../modules/vodafone_lab_mixins_module.js";

export default {
  mixins: [fandomBasicMixin, vodafoneLabNewsletterMixin]
};
</script>

<template>
  <div class="bg-vodafone py-3 px-md-4 bg-cover-center" footer-newsletter>
    <div class="container px-0">
      <div class="row m-0 py-3 py-md-4 justify-content-center text-white">
        <div class="col-12 col-md-10 col-lg-7 d-flex flex-column">
          <img :src="content.icon.url" v-if="content.icon" class="mx-auto mb-4 newsletter-icon" />
          <h4 class="text-center mb-4 text-uppercase">{{content.title}}</h4>
          <div class="w-100 mb-4 newsletter-description" v-html="content.description"></div>
        </div>
        <newsletter-form class="col-12 col-md-10 col-lg-7" :content="newsletterRecord" :opt-container-content="layoutContent" v-if="newsletterRecord"></newsletter-form>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[footer-newsletter] {
  min-height: 25rem;

  .newsletter-description {
    @include font-size(.875rem);
  }
}
</style>
